import React, { useState } from "react";
import DateCarousel from "../DateCarousel";
import MonthCarousel from "../MonthCarousel";
import useMediaQuery from "../../hooks/useMediaQuery";
import { getMonthName } from "../../utils/dateUtils";
import "./styles.css";

const CardDatas = ({ onDateClick }) => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth());

  const handleSelectMonth = (monthIndex) => {
    setSelectedMonth(monthIndex);
  };

  const handleSelectDate = (date) => {
    setSelectedDate(date);
    if (onDateClick) {
      onDateClick(date);
    }
  };

  return (
    <div className="dates">
      <h2>Agende seu horário</h2>
      <p>{selectedDate ? getMonthName(selectedDate) : ""}</p>
      {!isMobile && (
        <>
          <MonthCarousel onSelectMonth={handleSelectMonth} />
          <DateCarousel qntdItems={7} onSelectDate={handleSelectDate} selectedMonth={selectedMonth} />
        </>
      )}
    </div>
  );
};

export default CardDatas;
